<template>
    <div>
                    <div class="detail-card">
                      <div class="card card-colord-01 card-colord-pad">
                        <h6 class="margin-t-40">Set My Store's Discounts and Coupons</h6>
                        <p>Set discounts and coupons that would apply to all products and services in your sellpoint. 
                        </p>   
                        <!-- <p>You can set individual Product Discounts on thier product pages.</p> -->
                        <!-- <p v-if="sellpoint.business_discounts_coupons && (sellpoint.business_discounts_coupons.length == 0)" class="sp-app-default-color">
                          You have not set any dicount or coupon.
                        </p> -->
                        <p v-if="no_data" class="sp-app-default-color" style="color:#ff0000;">
                          You have not set any dicount or coupon.
                        </p>
                        <div class="card card-colord-01 card-colord-pad">
                          <button v-if="!business_details.setDiscount" class="btn sp-button-02 sp-button-sm" @click="setComponent('set-business-details','setDiscount')">Set New Discount Or Coupon</button>
                        </div>
                      </div>
                      <div class="card card-out-colord-pad" style="margin-top: 1em;">
                        <!-- Set Discounts -->
                        <div v-if="business_details.setDiscount">
                            <!-- <h5 style="font-size:13px">Set New Discount or Coupon</h5> -->
                            <div class="card" style="padding-left:0">
                              <!-- <div class="form-group" v-if="sellpoint.business_discounts_active != 1"> -->
                              <div v-if="sellpoint.business_discounts_active == 1">
                                <p style="color:#ff0000;">You have an ongoing active Discount</p>
                              </div>
      
                              <div class="form-group">
                                  <label>Set Coupon Or Discount</label>
                                  <select class="form-control" v-model="discount_coupon.is_discount_coupon">
                                  <option :value="undefined">Select</option>
                                  <option value="D">Discount</option>
                                  <option value="C">Coupon</option>
                                  </select>
                              </div>

                              <div class="form-group" style="display:none">
                                <label><input type="checkbox" v-model="discount_coupon_is_private">
                                  Private Coupon (code must be entered before use)  ?</label>
                              </div>

                              <div class="form-group" style="display:none">
                                <label><input type="checkbox" v-model="discount_coupon_is_direct">
                                  Direct Discount (for a particular user)  ?</label>
                              </div>

                              <div class="form-group wn-i-input-container" v-if="discount_coupon_is_direct">
                                <label>Enter username </label><br><div style="clear: both;"></div>
                                <input type="text" class="form-control wn-i-input-field" v-model="discount_coupon.discount_username"  @change="validateUsername(discount_coupon.discount_username)"/>
                                <i class="icon wn-i-input-icon fa fa-check" v-if="!action_verified.username"></i>
                                <i class="icon wn-i-input-icon fa fa-times" v-else style="color:#ff0000;"></i>
                              </div>

                              <div class="form-group" style="display:none">
                                <label><input type="checkbox" v-model="discount_coupon_is_gift_card">
                                  Do you want to set this as a gift card ?</label>
                              </div>

                              <div class="form-group" v-if="discount_coupon_is_gift_card">
                                <label>Minimum Amount for Gift Card <span class="sp-app-default-color"><b>NGN</b>5,000</span> </label>
                                <input type="number" class="form-control" v-model="discount_coupon.discount_min_amount"/>
                              </div>
                                
                              <div class="form-group">
                                  <label></label>
                                  <label v-if="sellpoint.business_discounts_active != 1">Select Discount Category</label>
                                  <label v-else>Select Coupon Discount Category</label>
                                  <select class="form-control" v-model="discount_coupon.discount_category">
                                  <option :value="undefined">Select Category</option>
                                  <option value="0">All Categories</option>
                                  <option v-for="cat in sellpoint.business_categories" :value="cat.business_category_id" :key="cat.business_category_id">{{cat.business_category_name}}</option>
                                  </select>
                              </div>
      
                              <div class="form-group">
                                  <!-- <label v-if="sellpoint.business_discounts_active != 1">Percentage Discount</label> -->
                                  <label>Percentage Discount</label>
                                  <input type="number" class="form-control" min="1" max="100" v-model="discount_coupon.discount_percentage"/>
                              </div>
      
                              <div class="form-group">
                                <label>Minimum Quantity</label>
                                <input type="number" class="form-control" v-model="discount_coupon.discount_min_quantity"/>
                              </div>
      
                              <div class="form-group">
                                  <label>Start Date</label>
                                  <!-- <input type="datetime-local" v-model="discount_coupon.discount_start_date"/> -->
                                  <input class="form-control" type="date" v-model="discount_coupon.discount_start_date"/>
                              </div>
      
                              <div class="form-group">
                                  <label>End Date</label>
                                  <input class="form-control" type="date" v-model="discount_coupon.discount_end_date"/>
                              </div>

                              <div class="form-group"  v-if="discount_coupon_is_gift_card">
                                <label>Add a Description <span class="sp-app-default-color">Optional except, if this is a gift card</span> </label>
                                <textarea class="form-control" v-model="discount_coupon.discount_description" style="height:250px;"></textarea>
                              </div>
                              <div class="form-group">
                                  <div class="loading-sm" v-if="action_loading"></div>
                                  <p style="color:#ff0000;">{{data_processing_message}}</p>
                                  <button :disabled="disable_btn" class="btn sp-button-02" @click="setDiscountsAndCoupons()">SET</button>
                                  <button class="btn sp-button-02" @click="setComponent('reset-edit','')" >Cancel</button>
                              </div>
                            </div>
                            <div class="row">
                              <p style="color:#363535; font-size: 14px;">Note that you can only set one Sellpoint Discount at a time.
                                  If you want to end an existing discount click on "Stop Discount" button near the
                                  button.
                              </p>
                            </div>
                        </div>
                        <!-- ./ Set Discounts -->
      
                        <!-- Edit Discounts -->
                        <div v-if="discount_coupon.edit && (!business_details.viewDiscounts || !business_details.setDiscount)">
                            <h5 style="font-size:13px">Edit Discount</h5>
                            <div class="" style="padding-left:0">
                              <div class="form-group">
                                <select class="form-control" v-model="discount_coupon.discount_category">
                                  <option :value="undefined">Select Another Category</option>
                                  <option value="0">All Categories</option>
                                  <option v-for="cat in sellpoint.business_categories" :value="cat.business_category_id" :key="cat.business_category_id">{{cat.business_category}}</option>
                                </select>
                              </div>
                              <div class="form-group">
                                <label>Percentage Discount</label>
                                <input class="form-control" type="number" min="1" max="100" v-model="discount_coupon.discount_percentage"/>
                              </div>
                              <div class="form-group">
                                <label>Minimum Quantity</label>
                                <input type="number" class="form-control" v-model="discount_coupon.discount_min_quantity"/>
                              </div>
                              <div class="form-group">
                                <label>Start Date1: {{discount_coupon.discount_start_date}}</label>
                                <!-- <input class="form-control" type="datetime-local" v-model="discount_coupon.discount_start_date"/> -->
                                <input class="form-control" type="date" v-model="discount_coupon.discount_start_date"/>
                              </div>
                              <div class="form-group">
                                <label>End Date: {{discount_coupon.discount_end_date}}</label>
                                <!-- <input class="form-control" type="datetime-local" v-model="discount_coupon.discount_end_date"/> -->
                                <input class="form-control" type="date" v-model="discount_coupon.discount_end_date"/>
                              </div>
                              <div class="form-group">
                                <div class="loading-sm" v-if="action_loading"></div>
                                <p style="color:#ff0000;">{{data_processing_message}}</p>
                                <button :disabled="disable_btn" class="btn sp-button-02" @click="editDiscountsAndCoupons()">Save</button>
                                <button class="btn sp-button-02" @click="setComponent('reset-edit','')" >Cancel</button>
                              </div>
                            </div>
                        </div>
                        <!-- ./-Edit Discounts -->
      
                        <!-- View Discounts -->
                        <div v-if="(!business_details.setDiscount && !discount_coupon.edit) && sellpoint.business_discounts_coupons">
                          <h5 style="font-size:13px" v-if="sellpoint.business_discounts_coupons && (sellpoint.business_discounts_coupons.length != 0)">View Discounts</h5>
                          <div class="row">
                            <div class="card card-flat-pad" v-for="(dc,index) in sellpoint.business_discounts_coupons" :key="dc.discount_id" style="border: #f7f7f7 solid !important;">
                              <div style="float:left; width:80%;">
                                <div>
                                  <p>{{dc.discount_percentage}}% Off</p>
                                <div style="clear:both;"></div>
                                </div>
                              </div>
                              <div style="float:right;">
                                <div>
                                  <a v-if="menu_tab_inner_view['DCM'+index]" style="cursor:pointer; color: inherit;" @click="setMenuTabInnerView('')">
                                    <div class="">
                                      <span class="card-link sp-app-default-color" v-if="dc.discount_status != ''" style="cursor:pointer; text-decoration: none;" >{{dc.discount_status}}</span> <i class="fa fa-angle-down"></i>
                                    </div>
                                  </a>
                                  <a v-else style="cursor:pointer; color: inherit;" @click="setMenuTabInnerView('DCM'+index)">
                                    <div class="">
                                      <span class="sp-app-default-color" style="cursor:pointer; text-decoration: none;" v-if="dc.discount_status != ''">{{dc.discount_status}}</span> <i class="fa fa-angle-down"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>
                              <div style="clear: both;"></div>
                              <div v-if="menu_tab_inner_view['DCM'+index]">
                                <div class="">
                                  <div style="border:#f1dee4 solid 1px; padding: 1em;">
                                    <div style="background:#d1ddf1; text-align: center;">
                                      <p v-if="dc.discount_coupon == 'D'"><b>Discount</b></p>
                                      <p v-if="dc.discount_coupon == 'C'"><b>Coupon:</b> (Code: {{dc.discount_coupon_code}} )</p>
                                    </div>
                                    <p v-if="(dc.discount_type == 4) || (dc.discount_type == 5)"><b>Type: </b>{{dc.discount_type_name}}</p>
                                    <p v-else><b>Type: </b>{{dc.discount_category_name}}</p>
                                    <p><b>%Discount: </b>{{dc.discount_percentage}}%</p>
                                    <p><b>Minimum Quantity: </b>{{dc.discount_min_quantity}}</p>
                                    <p><b>Start Date: </b>{{dc.discount_start_date}}</p>
                                    <p><b>End Date: </b>{{dc.discount_end_date}}</p>
                                    <p><b>Status: </b>{{dc.discount_status}}</p>
                                    <p><b>Added On: </b>{{dc.discount_reg_date}}</p>
                                    <div v-if="(dc.discount_type == 2) || (dc.discount_type == 3)">
                                      <p v-if="dc.discount_status_id == 5" >
                                        <a style="cursor:pointer; text-decoration:underline; font-size:13px; color:#448aff;" @click="setComponent('edit-discount-coupon',dc)" title="Edit">
                                          Edit</a> &nbsp;&nbsp;&nbsp; <i class="fa fa-circle-o-notch fa-spin 1x" v-if="action_loading"></i>
                                        <a style="cursor:pointer; text-decoration:underline; font-size:13px; color:#448aff;" @click="deactivateDiscountsAndCoupons(dc)" title="De-Activate">
                                          Deactivate</a>    
                                      </p>
                                    </div>
                                    <p v-if="(dc.discount_type == 4) || (dc.discount_type == 5)" style="color:#ff0000;">Edit/Deactivate at Product Settings</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- ./ View Discounts -->
                      </div> 
                    </div>
                </div>
</template>

<style>

</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
              no_data: true,
            }
        },

        methods: {
            setPage(){
              this.loading = false;
              //call funcs
              //this.loadCategories();
              if(this.sellpoint.store_sellpointDiscounts && (Object.keys(this.sellpoint.store_sellpointDiscounts).length > 0)){
                this.no_data = false;
                this.sellpoint.business_discounts_coupons = this.sellpoint.store_sellpointDiscounts;
              }
            },
        },

        components: {},

        created: function(){
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
              if(value != undefined) {
                self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                console.log(87766)
                console.log(self.sellpoint)
                self.setPage();
              }else{}
            });
        }

    }
</script>



// WEBPACK FOOTER //
// SellpointDiscounts.vue?70797d53